import React, { Component } from 'react';
import { Row, Col, Button, Icon, Tooltip } from 'antd';
import CaptchaStatus from './CaptchaStatus';
import CaptchaMask from './CaptchaMask';

export default class Captcha extends Component {
    state = { refreshType: 'default' }
    constructor(props) { super(props); }

    toggleRefreshType = () => this.setState({...this.state,
        refreshType: this.state.refreshType === 'default' ? 'primary' : 'default'
    });

    initialCaptchaSetup() {
        const { services } = this.props;
        services.loadCaptcha();
    }

    componentDidMount() {
        this.initialCaptchaSetup();
    }

    render() {


        const
        { services, state } = this.props,
        { validation } = state;
        return (
            <div>
                <Row>
                    <Col>
                        <div style={{
                            display: 'inline-block',
                            width: '202px',
                            height: '45px',
                            borderRadius: '5px',
                            borderStyle: 'solid',
                            borderWidth: '1px',
                            borderColor: 'rgb(217, 217, 217)'
                        }}>
                            <CaptchaStatus
                                readyToSubmit={state.field.length === 8 ? true : false}
                                request={state.request}
                                data={state.data}
                            />
                            {state.field.length === 8 ? <CaptchaMask /> : null}
                        </div>
                        <div style={{ display: 'inline-block' }}>
                            <Tooltip placement='top' title={
                                validation.status === 'success' || validation.status === 'failure'
                                ? 'Reset verification code.'
                                : 'Refresh verification code.'
                            }>
                                <Button
                                    disabled={
                                        validation.status === 'pending' ? true
                                        : validation.status === 'success' || validation.status === 'failure' ? false
                                        : validation.status == null ? state.field.length === 8 ? true : false : false
                                    }
                                    type={
                                        validation.status === 'success' || validation.status === 'failure' ? 'danger'
                                        : state.request.status === 'pending' ? 'dashed' : this.state.refreshType
                                    }
                                    onMouseOver={() => this.toggleRefreshType()}
                                    onMouseOut={() => this.toggleRefreshType()}
                                    onClick={() => { switch(validation.status) {
                                        case 'success':
                                        case 'failure':
                                            services.resetCaptchaValidation();
                                            services.loadCaptcha();
                                            this.props.resetField();
                                            break;
                                        default: {
                                                    services.loadCaptcha();
                                                    this.props.resetField();
                                                }
                                    }}}
                                    style={{
                                        width: '33px',
                                        height: '45px',
                                        marginLeft: '6px',
                                        top: '3px',
                                        borderStyle: 'solid',
                                        borderRadius: '5px'
                                    }}
                                >
                                    <Icon
                                        type={
                                            validation.status === 'success' || validation.status === 'failure' ? 'rollback'
                                            : state.request.status === 'pending' ? 'loading' : 'reload'
                                        }
                                        style={{ fontSize: '14px', fontWeight: 'bold' }}
                                    />
                                </Button>
                            </Tooltip>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}
